<template>
  <div @click="displayPrompt" class="px-4 py-4 list-item-component">
    <div class="vx-row">
      <div class="vx-col w-full sm:w-5/6 flex sm:items-center sm:flex-row flex-col">
        <div class="flex items-center">
          <!-- <vs-checkbox v-model="isCompleted" class="w-8 m-0 vs-checkbox-small" @click.stop /> -->
          <h6 class="todo-title"> Status:  {{ bookingLocal.status }}</h6>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <p class="mt-2 truncate flex justify-center "> Ordered by: {{ bookingLocal.customer_name?bookingLocal.customer_name: 'unknown booking' }}</p>
        <span class="mt-2 truncate flex justify-center">Ordered at: {{bookingLocal.booked_at_time}}</span>
        <span class="mt-2 truncate flex justify-center" v-if="bookingLocal.status == 'dispatched'" >Estimated Pickup Time: {{bookingLocal.estimated_pickup_time}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    booking: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      bookingLocal: this.booking
    };
  },
  methods: {
    displayPrompt() {
      this.$emit("showDisplayPrompt", this.booking);
    }
  }
};
</script>
